export const environment = {
  production: false,
  title: 'Development Environment',
};
